const Footer = () => {
 // Get the current timestamp in milliseconds
const currentTimestamp = Date.now();

// Create a Date object using the timestamp
const currentDate = new Date(currentTimestamp);

// Extract the date components
const year = currentDate.getFullYear();
const month = currentDate.getMonth() + 1; // Months are zero-based, so add 1
const day = currentDate.getDate();

// Create a string representation of today's date
const todayDateString = `${day < 10 ? '0' + day : day}-${month < 10 ? '0' + month : month}-${year}`;

// console.log(todayDateString);

  return (
    <div className=" ">
      <div className="border-b-2 border-solid border-neutral-400 h-2"></div>
      <h3 className="text-xl text-center pb-5">{todayDateString}</h3>
      
    </div>
  );
};

export default Footer;
